<template>
  <div id="success">
    <Spinner v-if="isLoading" />
    <div>
      <img class="image" src="../assets/Feed_logo.png" height="75%" width="75%" />

      <h1>Pedido registrado exitosamente</h1>

      <p><strong>Estado: </strong>{{ this.getStatus }}</p>
      <p v-if="payment_id !== undefined">
        <strong>Cod. Aut.: </strong>{{ this.payment_id }}
      </p>
      <!-- <p><strong>Ref: </strong>{{ this.externalReference }}</p> -->

      <article v-if="hasToShowQrUrl">
        <img :src="getQrUrl" />
      </article>

      <p v-if="hasToShowQrUrl == false">Ya estamos preparando tu pedido!</p>

      <p>
        <span v-if="hasToShowPayerEmail">Te mandamos un comprobante de pago a
          <strong>{{ this.getPayerEmail }}</strong>. De todos modos te recomendamos que hagas un screenshot de esta
          pantalla para que puedas presentar en la tienda!</span>
      </p>
      <p>Gracias!</p>
      <p>
        <md-button class="md-primary" @click="goToInit">Volver a pedir!</md-button>
      </p>
    </div>
  </div>
</template>
<script>
import Spinner from "../Components/Spinner";
import { http } from "../axios";
import { baseUrl, mySelfUrl } from "../server";
import QRCode from "qrcode";

export default {
  mounted() {
    this.externalReference = this.$route.query.externalReference;
    this.shopCode = this.$route.query.c;
    this.payment_id = this.$route.query.payment_id;

    if (this.externalReference !== null && this.externalReference !== undefined) {
      http
        .post(`${baseUrl}/api/PaymentConfirmed`, {
          ExternalReference: this.externalReference,
          Payment_id: this.payment_id
        })
        .then((response) => {
          console.log(`${JSON.stringify(response)}`);

          if (response.data.responseCode === 0) {
            this.payerMail = response.data.email;
            this.generateQrCode(response.data.qrFilePath);
            this.$store.commit("RESET_STATE");
            this.isLoading = false;
          } else {
            this.$router.push("Failure");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$router.push("Failure");
        });
    } else {
      this.$store.commit("RESET_STATE");
      this.isLoading = false;
    }
  },
  methods: {
    goToInit() {
      window.location.href = `${mySelfUrl}/#/SelfService?c=${this.shopCode}&o=Weborders&t=1`;
    },
    generateQrCode(qrFilePath) {
      QRCode.toDataURL(qrFilePath)
        .then((url) => {
          console.log(url);
          this.qrUrl = url;
          this.downloadQr(this.getQrUrl);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    downloadQr(qrUrl) {
      var download = document.createElement("a");
      download.href = qrUrl;
      download.download = `Qr-${this.externalReference}.png`;
      download.click();
    },
  },
  data() {
    return {
      externalReference: null,
      shopCode: null,
      payment_id: null,
      isLoading: true,
      payerMail: null,
      qrUrl: null
    };
  },
  computed: {
    getPayerEmail() {
      return this.payerMail;
    },
    getQrUrl() {
      return this.qrUrl;
    },
    hasToShowPayerEmail() {
      return this.payerMail !== null;
    },
    hasToShowQrUrl() {
      return this.qrUrl !== null;
    },
    getStatus() {
      return "Aprobada";
      // switch (this.status) {
      //   case "approved":
      //     return "Aprobada";
      //   default:
      //     return this.status;
      // }
    },
  },
  components: {
    Spinner,
  },
};
</script>
<style scoped>
#success {
  height: 40em;
  padding-bottom: 100vh;
}

.image {
  height: 500;
  width: 500;
  padding-bottom: 3vh;
}

#success div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/Success.vue